// The pre-wired backend instances a feature `api/` class imports (contract 03 §6).
// Base URLs come from the typed env (module 01), resolved LAZILY: `useEnv()` throws before
// boot's `validateEnv()`, so reading it here at module-eval would crash any importer that
// loads before bootstrap. The resolver defers env access to the first request instead.
//
// Only `appHttp` and `controllerHttp` ship in this prerequisite. The optional RAG instance
// is intentionally absent (ledger B5: Orpheus stays on appHttp; a split service needs a new
// published migration contract before a rag client returns).
import { createHttpClient } from './createHttpClient'

import { useEnv } from '@/shared/config'

const CONTROLLER_TIMEOUT_MS = 120_000

/** Django app API — the bulk of the app. Envelope on user routes, flat under /admin-panel/. */
export const appHttp = createHttpClient({ baseURL: () => useEnv().API_APP_URL })

/**
 * Report/controller service (heavy analytics). 120s timeout; module 05 binds a per-navigation
 * `controllerHttp.defaults.signal` so an in-flight report auto-aborts on navigation.
 */
export const controllerHttp = createHttpClient({
  baseURL: () => useEnv().API_CONTROLLER_URL,
  timeoutMs: CONTROLLER_TIMEOUT_MS,
})
